import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';

import FieldError from '../../components/FieldError';
import Tooltip from '../../components/Tooltip';


const renderField = (
  {
    input,
    meta: { touched, error },
    label,
    tooltipText,
    placeholder = '',
    errorClassNames = '',
    ...rest
  },
) => (
  <FormGroup noMargin className="form-group">
    <Label>{label}</Label>
    {tooltipText && <Tooltip text={tooltipText} />}
    <Input
      {...input}
      {...rest}
      placeholder={placeholder || label}
    />
    {touched && error && <FieldError error={error} classNames={errorClassNames} />}
  </FormGroup>
);

renderField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  tooltipText: PropTypes.string,
  errorClassNames: PropTypes.string,
};

export default renderField;
